import React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as Auth from '../store/Auth';
import CustomerSearch from './CustomerSearch';
import CustomerDetails from './CustomerDetails';
import CustomerLookup from './CustomerLookup';
import * as PolicyGrid from './PolicyGrid';
import Payment from './Payment';
import { actionCreators } from '../store/Customer';

type HomeProps = Auth.LoginState & typeof actionCreators;

const Home = (props: HomeProps) => {

  const [showPayment, setShowPayment] = useState(false);

  const onPay = (items: PolicyGrid.Payments[]) => {
    console.log(`onPay clicked ${JSON.stringify(items)}`);
    if (items.length>0) {
      setShowPayment(true);
    }
  };

    return (

        <div style={{ padding: "2em 0" }}>            

            {/*!showPayment && <><CustomerDetails onPay={onPay} /><br /></>*/}
            {!showPayment && <><CustomerLookup onPay={onPay} /><br /></>}
            {/*!showPayment && <PolicyGrid.default onPay={onPay} />*/}
            {showPayment && <div> <Payment onClose={() => { setShowPayment(false); props.clearPaymentError() }} /> </div>}
      
        </div>

  );
};

export default connect((state: ApplicationState) => state.auth, actionCreators)(Home);